// extracted by mini-css-extract-plugin
export var dropdownButton = "_4j-0";
export var fullWidthDropdownButton = "_4j-1";
export var icon = "_4j-3";
export var iconPlaceholder = "_4j-2";
export var menuItemRow = "_4j-9";
export var separator = "_4j-e";
export var shortcutContainer = "_4j-7";
export var shortcutContainerFilled = "_4j-8";
export var shortcutIconLg = "_4j-6";
export var shortcutIconMd = "_4j-5";
export var shortcutIconSm = "_4j-4";
export var submenuChevron = "_4j-d";
export var submenuDropdown = "_4j-a";
export var submenuTriggerRow = "_4j-b";
export var submenuTriggerRowOpen = "_4j-c";